import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Menu, IconGroup, Icon } from 'semantic-ui-react'

export default function SiteHeader({ menuItems }) {
  const handleMenu = (remove_show) => {
    let item = document.getElementById('top-nav-menu')
    if (item.classList.contains('show-menu') || remove_show) {
      item.classList.remove('show-menu')
    } else if (!remove_show) {
      item.classList.add('show-menu')
    }
  }

  return (
    <div className="header-wrapper">
      <Container>
        <Menu stackable borderless className="top-nav" id="top-nav-menu">
          <Menu.Item header className="top-logo">
            <Link to="" className="a-logo" title="Clark Tree Services">
              Clark Tree Services
            </Link>
            {/* <div className="description">Let us know if you need some trees cut.</div> */}

            <IconGroup onClick={() => handleMenu()} className="menu-group">
              <Icon bordered link name="sidebar" className="menu-btn" />
              <p className="menu-label">menu</p>
            </IconGroup>
          </Menu.Item>

          <Menu.Menu position="right" className="nav-menu">
            {menuItems.map((item) => (
              <Menu.Item
                key={item.path}
                as={Link}
                link
                to={item.path}
                onClick={() => handleMenu(true)}>
                {item.name}
              </Menu.Item>
            ))}
          </Menu.Menu>
        </Menu>
      </Container>
    </div>
  )
}
